const doc = [({"da":({"js":({"admin":({"roles":({"ability_groups":({"ability_groups_for":"Adgangsgrupper for %{role}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;